export enum AnalyticsEventName {
  Business = 'Widget_Business',
  Click = 'Widget_Click',
  View = 'Widget_View',
}
